import React, { useState, useEffect, useRef } from 'react';
import { Plus, Dumbbell, Calendar, Target, TrendingUp, Award, Flame, Zap, Trophy, Edit3, Play, BarChart3, User, Settings, Timer, BookOpen, Filter, Star, Watch, Heart, Activity, Wifi, WifiOff, Apple, Droplets, Camera, Utensils, Pause, SkipForward, RotateCcw, CheckCircle, Clock, ArrowRight, ArrowLeft, BrainCircuit, Mic, MicOff } from 'lucide-react';
import { masterSupabase as supabase } from "../lib/supabase-master.js";
import HealthConnectService from './HealthConnectService_Enhanced.js';
import NutritionAIService from './NutritionAIService.js';

const VitalCenter = () => {
  const [user, setUser] = useState(null);
  const [fitnessData, setFitnessData] = useState(null);
  const [challengeData, setChallengeData] = useState(null);
  const [trainingLogs, setTrainingLogs] = useState([]);
  const [weeklyStats, setWeeklyStats] = useState(null);
  const [workoutPlans, setWorkoutPlans] = useState([]);
  const [exerciseLibrary, setExerciseLibrary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showWorkoutModal, setShowWorkoutModal] = useState(false);
  const [showWorkoutPlanModal, setShowWorkoutPlanModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState('all');
  const [selectedDifficulty, setSelectedDifficulty] = useState('all');
  
  // ENHANCED SAMSUNG HEALTH INTEGRATION
  const [healthService, setHealthService] = useState(null);
  const [healthData, setHealthData] = useState(null);
  const [healthScore, setHealthScore] = useState(0);
  const [healthConnected, setHealthConnected] = useState(false);
  const [healthSyncStatus, setHealthSyncStatus] = useState('initializing');
  const [lastSyncTime, setLastSyncTime] = useState(null);

  // ERNÄHRUNGS-INTEGRATION
  const [nutritionService, setNutritionService] = useState(null);
  const [nutritionData, setNutritionData] = useState(null);
  const [nutritionGoals, setNutritionGoals] = useState(null);
  const [todaysMeals, setTodaysMeals] = useState([]);
  const [waterIntake, setWaterIntake] = useState(0);
  const [showNutritionModal, setShowNutritionModal] = useState(false);
  const [mealPhoto, setMealPhoto] = useState(null);
  const [mealAnalysis, setMealAnalysis] = useState(null);

  // 90-TAGE BODY TRANSFORMATION SYSTEM
  const [activeWorkoutPlan, setActiveWorkoutPlan] = useState(null);
  const [workoutSessions, setWorkoutSessions] = useState([]);
  const [currentWorkout, setCurrentWorkout] = useState(null);
  const [workoutTimer, setWorkoutTimer] = useState(0);
  const [isWorkoutActive, setIsWorkoutActive] = useState(false);
  const [isWorkoutPaused, setIsWorkoutPaused] = useState(false);
  const [currentExerciseIndex, setCurrentExerciseIndex] = useState(0);
  const [currentSet, setCurrentSet] = useState(1);
  const [exerciseTimer, setExerciseTimer] = useState(0);
  const [restTimer, setRestTimer] = useState(0);
  const [isResting, setIsResting] = useState(false);
  const [completedExercises, setCompletedExercises] = useState([]);
  const [workoutSession, setWorkoutSession] = useState(null);
  const [showWorkoutScreen, setShowWorkoutScreen] = useState(false);

  // CLARA'S COACHING SYSTEM
  const [aiCoach, setAiCoach] = useState(null);
  const [aiRecommendations, setAiRecommendations] = useState([]);
  const [adaptiveDifficulty, setAdaptiveDifficulty] = useState(1);
  const [showRepInputModal, setShowRepInputModal] = useState(false);
  const [currentReps, setCurrentReps] = useState(0);
  const [isListening, setIsListening] = useState(false);
  const recognitionRef = useRef(null);
  
  const [profileForm, setProfileForm] = useState({
    height_cm: '',
    current_weight_kg: '',
    goal_weight_kg: '',
    fitness_level: 'beginner',
    preferred_workout_days: 5,
    preferred_workout_duration: 45,
    preferred_workout_time: 'morning'
  });

  const [workoutForm, setWorkoutForm] = useState({
    exercise: '',
    weight: '',
    sets: '',
    reps: '',
    notes: ''
  });

  // 90-TAGE BODY TRANSFORMATION PROGRAMM
  const bodyTransformationProgram = [
    {
      id: 'foundation_phase',
      name: "Foundation Phase (Tage 1-30)",
      description: "Aufbau der Grundfitness, Fokus auf Form und Beweglichkeit. Stärkung des unteren Rückens und Core-Stabilität für eine solide Basis.",
      difficulty_level: 1,
      duration_days: 30,
      phase: 1,
      workouts_per_week: 4,
      color: 'from-blue-800 to-blue-700',
      exercises: [
        { 
          name: 'Push-ups', 
          sets: 3, 
          reps: '8-12', 
          rest: 60, 
          instructions: 'Starte in Plank-Position. Senke den Körper bis die Brust fast den Boden berührt. Drücke dich kraftvoll nach oben. Halte den Körper gerade.',
          progression: 'Woche 1-2: 8 Reps, Woche 3-4: 12 Reps',
          muscles: 'Brust, Trizeps, Schultern'
        },
        { 
          name: 'Bodyweight Squats', 
          sets: 3, 
          reps: '12-15', 
          rest: 60, 
          instructions: 'Füße schulterbreit, Zehen leicht nach außen. Senke dich als würdest du dich hinsetzen. Knie nicht über Zehenspitzen. Drücke durch die Fersen hoch.',
          progression: 'Woche 1-2: 12 Reps, Woche 3-4: 15 Reps',
          muscles: 'Quadrizeps, Gesäß, Waden'
        },
        { 
          name: 'Dead Bug', 
          sets: 3, 
          reps: '10 pro Seite', 
          rest: 45, 
          instructions: 'Rückenlage, Arme senkrecht nach oben, Knie 90°. Senke gegenüberliegenden Arm und Bein langsam ab. Core angespannt halten.',
          progression: 'Woche 1-2: 8 pro Seite, Woche 3-4: 12 pro Seite',
          muscles: 'Core, unterer Rücken'
        },
        { 
          name: 'Plank', 
          sets: 3, 
          reps: '30-45 Sek', 
          rest: 60, 
          instructions: 'Unterarmstütz. Körper bildet gerade Linie von Kopf bis Fersen. Bauch anspannen, nicht durchhängen oder Hüfte hochdrücken.',
          progression: 'Woche 1-2: 30 Sek, Woche 3-4: 45 Sek',
          muscles: 'Core, Schultern, Rücken'
        },
        { 
          name: 'Wall Sit', 
          sets: 3, 
          reps: '30-60 Sek', 
          rest: 60, 
          instructions: 'Rücken an die Wand, rutschen bis Knie 90° Winkel. Gewicht auf den Fersen. Oberschenkel parallel zum Boden.',
          progression: 'Woche 1-2: 30 Sek, Woche 3-4: 60 Sek',
          muscles: 'Quadrizeps, Gesäß'
        },
        { 
          name: 'Mountain Climbers', 
          sets: 3, 
          reps: '20 pro Seite', 
          rest: 45, 
          instructions: 'Plank-Position. Ziehe abwechselnd Knie zur Brust. Schnelle Wechsel, aber Core stabil halten. Hüfte nicht hochdrücken.',
          progression: 'Woche 1-2: 15 pro Seite, Woche 3-4: 25 pro Seite',
          muscles: 'Core, Schultern, Cardio'
        }
      ]
    },
    {
      id: 'strength_phase',
      name: "Strength Phase (Tage 31-60)",
      description: "Kraftaufbau mit progressiver Belastung. Integration von schwereren Übungen und komplexeren Bewegungsmustern für Muskelwachstum.",
      difficulty_level: 2,
      duration_days: 30,
      phase: 2,
      workouts_per_week: 5,
      color: 'from-orange-800 to-orange-700',
      exercises: [
        { 
          name: 'Diamond Push-ups', 
          sets: 4, 
          reps: '6-10', 
          rest: 90, 
          instructions: 'Hände bilden Diamant unter der Brust. Schwieriger als normale Push-ups. Fokus auf Trizeps. Langsame, kontrollierte Bewegung.',
          progression: 'Woche 5-6: 6 Reps, Woche 7-8: 10 Reps',
          muscles: 'Trizeps, Brust, Schultern'
        },
        { 
          name: 'Jump Squats', 
          sets: 4, 
          reps: '12-15', 
          rest: 90, 
          instructions: 'Normale Squat-Position. Explosive Sprung nach oben. Weiche Landung in Squat-Position. Arme für Balance nutzen.',
          progression: 'Woche 5-6: 10 Reps, Woche 7-8: 15 Reps',
          muscles: 'Quadrizeps, Gesäß, Waden, Power'
        },
        { 
          name: 'Pike Push-ups', 
          sets: 3, 
          reps: '8-12', 
          rest: 75, 
          instructions: 'Hände schulterbreit, Hüfte hoch (umgekehrtes V). Senke Kopf Richtung Boden zwischen den Händen. Vorbereitung für Handstand Push-ups.',
          progression: 'Woche 5-6: 6 Reps, Woche 7-8: 10 Reps',
          muscles: 'Schultern, Trizeps, oberer Rücken'
        },
        { 
          name: 'Single Leg Glute Bridge', 
          sets: 3, 
          reps: '12 pro Bein', 
          rest: 90, 
          instructions: 'Rückenlage, ein Bein angewinkelt, anderes gestreckt. Hüfte hoch drücken. Gesäß anspannen. Langsam senken.',
          progression: 'Woche 5-6: 10 pro Bein, Woche 7-8: 15 pro Bein',
          muscles: 'Gesäß, hintere Oberschenkel'
        },
        { 
          name: 'Burpees', 
          sets: 3, 
          reps: '8-12', 
          rest: 90, 
          instructions: 'Squat, Hände auf Boden, springe in Plank, Push-up, springe zurück zu Squat, Strecksprung nach oben. Flüssige Bewegung.',
          progression: 'Woche 5-6: 6 Reps, Woche 7-8: 10 Reps',
          muscles: 'Ganzkörper, Cardio, Kraft'
        },
        { 
          name: 'Side Plank', 
          sets: 3, 
          reps: '30-45 Sek pro Seite', 
          rest: 75, 
          instructions: 'Seitenlage auf Unterarm. Körper gerade Linie. Hüfte hoch halten. Nicht nach vorne oder hinten kippen.',
          progression: 'Woche 5-6: 30 Sek, Woche 7-8: 45 Sek',
          muscles: 'Seitliche Core-Muskulatur'
        },
        { 
          name: 'Reverse Lunges', 
          sets: 3, 
          reps: '12 pro Bein', 
          rest: 90, 
          instructions: 'Schritt nach hinten, beide Knie 90°. Vorderes Knie über Knöchel. Drücke durch vordere Ferse zurück zur Startposition.',
          progression: 'Woche 5-6: 10 pro Bein, Woche 7-8: 15 pro Bein',
          muscles: 'Quadrizeps, Gesäß, Stabilität'
        }
      ]
    },
    {
      id: 'power_phase',
      name: "Power Phase (Tage 61-90)",
      description: "Explosive Kraft und athletische Performance. Fortgeschrittene Übungen und komplexe Bewegungen für maximale Body Transformation.",
      difficulty_level: 3,
      duration_days: 30,
      phase: 3,
      workouts_per_week: 5,
      color: 'from-purple-800 to-purple-700',
      exercises: [
        { 
          name: 'Archer Push-ups', 
          sets: 4, 
          reps: '5-8 pro Seite', 
          rest: 120, 
          instructions: 'Breite Push-up Position. Gewicht auf einen Arm verlagern, anderen Arm gestreckt zur Seite. Einseitige Belastung für maximale Kraft.',
          progression: 'Woche 9-10: 4 pro Seite, Woche 11-12: 8 pro Seite',
          muscles: 'Brust, Trizeps, Core (einseitig)'
        },
        { 
          name: 'Pistol Squats', 
          sets: 3, 
          reps: '5-8 pro Bein', 
          rest: 120, 
          instructions: 'Einbeinige Kniebeuge. Ein Bein gestreckt nach vorne. Langsam runter bis Gesäß fast Boden berührt. Balance und Kraft.',
          progression: 'Woche 9-10: 3 pro Bein, Woche 11-12: 6 pro Bein',
          muscles: 'Quadrizeps, Gesäß, Balance'
        },
        { 
          name: 'Handstand Push-ups (Wand)', 
          sets: 3, 
          reps: '3-6', 
          rest: 180, 
          instructions: 'Handstand an der Wand. Langsam Kopf Richtung Boden senken. Kraftvoll nach oben drücken. Fortgeschrittenste Push-up Variante.',
          progression: 'Woche 9-10: 2 Reps, Woche 11-12: 5 Reps',
          muscles: 'Schultern, Trizeps, Core'
        },
        { 
          name: 'L-Sit', 
          sets: 3, 
          reps: '15-30 Sek', 
          rest: 90, 
          instructions: 'Sitz mit Händen neben Hüften. Drücke dich hoch, Beine gestreckt parallel zum Boden. Extreme Core-Kraft erforderlich.',
          progression: 'Woche 9-10: 10 Sek, Woche 11-12: 25 Sek',
          muscles: 'Core, Schultern, Trizeps'
        },
        { 
          name: 'Explosive Push-ups', 
          sets: 4, 
          reps: '6-10', 
          rest: 120, 
          instructions: 'Push-up mit explosiver Aufwärtsbewegung. Hände verlassen kurz den Boden. Weiche Landung. Maximale Power-Entwicklung.',
          progression: 'Woche 9-10: 5 Reps, Woche 11-12: 8 Reps',
          muscles: 'Brust, Trizeps, Power'
        },
        { 
          name: 'Bulgarian Split Squats', 
          sets: 3, 
          reps: '12-15 pro Bein', 
          rest: 90, 
          instructions: 'Hinteres Bein auf Bank/Stuhl. Tiefe Kniebeuge auf vorderem Bein. Fokus auf Balance und Kraft. Schwieriger als normale Lunges.',
          progression: 'Woche 9-10: 10 pro Bein, Woche 11-12: 15 pro Bein',
          muscles: 'Quadrizeps, Gesäß, Stabilität'
        },
        { 
          name: 'Planche Lean', 
          sets: 3, 
          reps: '20-30 Sek', 
          rest: 90, 
          instructions: 'Plank-Position. Gewicht nach vorne verlagern über die Hände. Schultern vor Handgelenke. Vorbereitung für Planche.',
          progression: 'Woche 9-10: 15 Sek, Woche 11-12: 30 Sek',
          muscles: 'Schultern, Core, Handgelenke'
        },
        { 
          name: 'Tuck Jump to Burpee', 
          sets: 3, 
          reps: '8-12', 
          rest: 120, 
          instructions: 'Tuck Jump (Knie zur Brust), landen in Squat, sofort in Burpee übergang. Explosive Kombination für maximale Intensität.',
          progression: 'Woche 9-10: 6 Reps, Woche 11-12: 10 Reps',
          muscles: 'Ganzkörper, Cardio, Explosivität'
        }
      ]
    }
  ];

  // TIMER EFFECTS
  useEffect(() => {
    let interval = null;
    if (isWorkoutActive && !isWorkoutPaused) {
      interval = setInterval(() => {
        setWorkoutTimer(timer => timer + 1);
        if (isResting && restTimer > 0) {
          setRestTimer(timer => timer - 1);
        } else if (isResting && restTimer === 0) {
          setIsResting(false);
          setRestTimer(0);
        } else if (!isResting) {
          setExerciseTimer(timer => timer + 1);
        }
      }, 1000);
    } else if (!isWorkoutActive) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isWorkoutActive, isWorkoutPaused, isResting, restTimer]);

  useEffect(() => {
    initializeApp();
    
    // Cleanup beim Unmount
    return () => {
      if (healthService) {
        healthService.destroy();
      }
      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
    };
  }, []);

  const initializeApp = async () => {
    try {
      setLoading(true);
      
      // Parallel laden für bessere Performance
      await Promise.all([
        loadUserData(),
        loadWorkoutPlans(),
        loadExerciseLibrary(),
        initializeHealthService(),
        initializeNutritionService(),
        loadWorkoutProgress()
      ]);
      
      setLoading(false);
    } catch (error) {
      console.error('App Initialisierung fehlgeschlagen:', error);
      setLoading(false);
    }
  };

  const initializeHealthService = async () => {
    try {
      console.log('🚀 Initialisiere Enhanced Health Connect Service...');
      setHealthSyncStatus('connecting');
      
      const service = new HealthConnectService();
      const initialized = await service.initialize();
      
      if (initialized) {
        setHealthService(service);
        setHealthConnected(service.isConnected);
        setHealthSyncStatus(service.isConnected ? 'connected' : 'mock');
        
        // Erste Daten laden
        const initialData = await service.getHealthData();
        setHealthData(initialData);
        setHealthScore(initialData.healthScore);
        setLastSyncTime(initialData.lastSync);
        
        console.log('✅ Health Connect Service erfolgreich initialisiert');
        
        // Starte Live-Updates
        startHealthDataUpdates(service);
        
      } else {
        setHealthSyncStatus('error');
        console.error('❌ Health Connect Service Initialisierung fehlgeschlagen');
      }
    } catch (error) {
      console.error('❌ Health Service Initialisierung Fehler:', error);
      setHealthSyncStatus('error');
    }
  };

  const initializeNutritionService = async () => {
    try {
      console.log('🍏 Initialisiere Nutrition AI Service...');
      const service = new NutritionAIService();
      setNutritionService(service);
      await loadNutritionData();
      console.log('✅ Nutrition AI Service erfolgreich initialisiert');
    } catch (error) {
      console.error('❌ Nutrition AI Service Initialisierung Fehler:', error);
    }
  };

  const startHealthDataUpdates = (service) => {
    // Produktions-Update alle 5 Minuten
    const updateInterval = setInterval(async () => {
      try {
        const freshData = await service.getHealthData();
        setHealthData(freshData);
        setHealthScore(freshData.healthScore);
        setLastSyncTime(freshData.lastSync);
        setHealthConnected(freshData.isConnected);
        
        console.log('🔄 Health Data automatisch aktualisiert');
      } catch (error) {
        console.error('❌ Health Data Update fehlgeschlagen:', error);
      }
    }, 300000); // 5 Minuten

    // Cleanup Funktion für das Interval
    return () => clearInterval(updateInterval);
  };

  const loadWorkoutProgress = async () => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      if (!currentUser) {
        // Mock-Daten wenn nicht angemeldet
        setChallengeData({
          currentChallenge: "90-Tage Body Transformation",
          progress: 15,
          daysRemaining: 76,
          streak: 3,
          daysPassed: 14,
          totalWorkouts: 8,
          currentPhase: 1
        });
        return;
      }

      // Lade Workout Sessions der letzten 90 Tage
      const ninetyDaysAgo = new Date();
      ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

      const { data: sessions, error } = await supabase
        .from('workout_sessions')
        .select('*')
        .eq('user_id', currentUser.id)
        .gte('start_time', ninetyDaysAgo.toISOString())
        .order('start_time', { ascending: false });

      if (error) {
        console.error('Error loading workout sessions:', error);
        setChallengeData({
          currentChallenge: "90-Tage Body Transformation",
          progress: 0,
          daysRemaining: 90,
          streak: 0,
          daysPassed: 0,
          totalWorkouts: 0,
          currentPhase: 1
        });
        return;
      }

      setWorkoutSessions(sessions || []);

      // Berechne Challenge-Fortschritt basierend auf Sessions
      const totalWorkouts = sessions?.length || 0;
      const daysPassed = Math.min(totalWorkouts * 1.5, 90); // Grobe Schätzung
      const progress = Math.round((daysPassed / 90) * 100);
      const daysRemaining = Math.max(90 - daysPassed, 0);

      // Berechne Streak (vereinfacht)
      let streak = 0;
      if (sessions && sessions.length > 0) {
        const today = new Date();
        const lastWorkout = new Date(sessions[0].start_time);
        const daysDiff = Math.floor((today - lastWorkout) / (1000 * 60 * 60 * 24));
        
        if (daysDiff <= 1) {
          streak = Math.min(sessions.length, 7); // Max 7 Tage Streak anzeigen
        }
      }

      // Bestimme aktuelle Phase basierend auf Fortschritt
      let currentPhase = 1;
      if (daysPassed > 60) currentPhase = 3;
      else if (daysPassed > 30) currentPhase = 2;

      setChallengeData({
        currentChallenge: "90-Tage Body Transformation",
        progress: progress,
        daysRemaining: daysRemaining,
        streak: streak,
        daysPassed: Math.round(daysPassed),
        totalWorkouts: totalWorkouts,
        currentPhase: currentPhase
      });

    } catch (error) {
      console.error('Error loading workout progress:', error);
      setChallengeData({
        currentChallenge: "90-Tage Body Transformation",
        progress: 0,
        daysRemaining: 90,
        streak: 0,
        daysPassed: 0,
        totalWorkouts: 0,
        currentPhase: 1
      });
    }
  };

  const loadUserData = async () => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      if (!currentUser) {
        // Mock-Daten wenn nicht angemeldet
        setWeeklyStats({
          workoutsCompleted: 4,
          totalMinutes: 180,
          caloriesBurned: 850,
          avgHeartRate: 142
        });

        setTrainingLogs([
          { id: 1, exercise: 'Push-ups', sets: 3, reps: 15, weight: 0, date: '2024-08-17' },
          { id: 2, exercise: 'Jump Squats', sets: 4, reps: 12, weight: 0, date: '2024-08-17' },
          { id: 3, exercise: 'Burpees', sets: 3, reps: 8, weight: 0, date: '2024-08-16' }
        ]);
        return;
      }
      
      setUser(currentUser);

      // Load fitness goals
      const { data: fitness, error: fitnessError } = await supabase
        .from('user_fitness_goals')
        .select('*')
        .eq('user_id', currentUser.id)
        .single();

      if (fitnessError && fitnessError.code !== 'PGRST116') {
        console.error('Error loading fitness data:', fitnessError);
      } else if (fitness) {
        setFitnessData(fitness);
        setProfileForm({
          height_cm: fitness.height_cm || '',
          current_weight_kg: fitness.current_weight_kg || '',
          goal_weight_kg: fitness.goal_weight_kg || '',
          fitness_level: fitness.fitness_level || 'beginner',
          preferred_workout_days: fitness.preferred_workout_days || 5,
          preferred_workout_duration: fitness.preferred_workout_duration || 45,
          preferred_workout_time: fitness.preferred_workout_time || 'morning'
        });
      }

      // Load weekly stats (mock for now)
      setWeeklyStats({
        workoutsCompleted: 4,
        totalMinutes: 180,
        caloriesBurned: 850,
        avgHeartRate: 142
      });

      // Load training logs (mock for now)
      setTrainingLogs([
        { id: 1, exercise: 'Push-ups', sets: 3, reps: 15, weight: 0, date: '2024-08-17' },
        { id: 2, exercise: 'Jump Squats', sets: 4, reps: 12, weight: 0, date: '2024-08-17' },
        { id: 3, exercise: 'Burpees', sets: 3, reps: 8, weight: 0, date: '2024-08-16' }
      ]);

    } catch (error) {
      console.error('Error loading user data:', error);
    }
  };

  const loadNutritionData = async () => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      if (!currentUser) {
        // Mock-Daten wenn nicht angemeldet
        setNutritionData({
          calories: 1850,
          protein: 95,
          water: 2.1,
          mealsCount: 3
        });
        setWaterIntake(2100);
        return;
      }

      // Load nutrition goals
      const { data: goals, error: goalsError } = await supabase
        .from('nutrition_goals')
        .select('*')
        .eq('user_id', currentUser.id)
        .single();

      if (goals) {
        setNutritionGoals(goals);
      }

      // Load today's meals
      const today = new Date().toISOString().split('T')[0];
      const { data: meals, error: mealsError } = await supabase
        .from('meals')
        .select(`
          *,
          meal_items (
            *,
            food_database (name, category)
          )
        `)
        .eq('user_id', currentUser.id)
        .eq('meal_date', today)
        .order('meal_time', { ascending: true });

      if (meals) {
        setTodaysMeals(meals);
      }

      // Load water intake for today
      const { data: water, error: waterError } = await supabase
        .from('water_intake')
        .select('amount_ml')
        .eq('user_id', currentUser.id)
        .eq('intake_date', today);

      if (water) {
        const totalWater = water.reduce((sum, entry) => sum + entry.amount_ml, 0);
        setWaterIntake(totalWater);
      }

      // Calculate nutrition summary
      const totalCalories = meals?.reduce((sum, meal) => sum + (meal.total_calories || 0), 0) || 0;
      const totalProtein = meals?.reduce((sum, meal) => sum + (meal.total_protein || 0), 0) || 0;

      setNutritionData({
        calories: totalCalories,
        protein: totalProtein,
        water: waterIntake / 1000, // Convert to liters
        mealsCount: meals?.length || 0
      });

    } catch (error) {
      console.error('Error loading nutrition data:', error);
      // Fallback zu Mock-Daten
      setNutritionData({
        calories: 1850,
        protein: 95,
        water: 2.1,
        mealsCount: 3
      });
      setWaterIntake(2100);
    }
  };

  const loadWorkoutPlans = async () => {
    try {
      console.log('💪 Lade 90-Tage Body Transformation Programm...');
      
      // Verwende das vollständige Body Transformation Programm
      setWorkoutPlans(bodyTransformationProgram);
      console.log('✅ 90-Tage Body Transformation Programm geladen');

    } catch (error) {
      console.error('Error loading workout plans:', error);
      setWorkoutPlans(bodyTransformationProgram);
    }
  };

  const loadExerciseLibrary = async () => {
    try {
      const { data, error } = await supabase
        .from('exercise_library')
        .select('*')
        .order('name', { ascending: true });

      if (error) {
        console.error('Error loading exercise library:', error);
        // Fallback zu Mock-Daten
        setExerciseLibrary([
          { id: 1, name: 'Push-ups', category: 'calisthenics', equipment: 'bodyweight', target_muscles: ['chest', 'triceps'], difficulty_level: 1 },
          { id: 2, name: 'Jump Squats', category: 'strength', equipment: 'bodyweight', target_muscles: ['quadriceps', 'glutes'], difficulty_level: 2 },
          { id: 3, name: 'Burpees', category: 'cardio', equipment: 'bodyweight', target_muscles: ['full_body'], difficulty_level: 2 }
        ]);
      } else {
        setExerciseLibrary(data || []);
      }
    } catch (error) {
      console.error('Error loading exercise library:', error);
    }
  };

  // 90-TAGE BODY TRANSFORMATION FUNKTIONEN
  const start90DayTransformation = async () => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      
      // Setze Foundation Phase als aktiv
      const foundationPhase = bodyTransformationProgram.find(plan => plan.phase === 1);
      if (foundationPhase) {
        setActiveWorkoutPlan(foundationPhase);
        
        // Update Challenge Data
        setChallengeData(prev => ({
          ...prev,
          currentChallenge: "90-Tage Body Transformation - AKTIV",
          currentPhase: 1
        }));

        console.log('🚀 90-Tage Body Transformation gestartet!');
      }
    } catch (error) {
      console.error('Error starting 90-day transformation:', error);
    }
  };

  // WORKOUT FUNKTIONEN
  const startWorkout = async (phaseId = null) => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      
      // Bestimme aktuelle Phase
      let currentPhase = challengeData?.currentPhase || 1;
      if (phaseId) currentPhase = phaseId;
      
      const selectedPlan = bodyTransformationProgram.find(plan => plan.phase === currentPhase);
      
      if (!selectedPlan) {
        console.error('Kein Workout-Plan gefunden');
        return;
      }

      console.log('🏋️ Starte Workout:', selectedPlan.name);

      // Erstelle Workout Session wenn angemeldet
      if (currentUser) {
        const sessionData = {
          user_id: currentUser.id,
          workout_plan_id: null, // Verwende null für Body Transformation Programm
          session_name: `${selectedPlan.name} - ${new Date().toLocaleDateString('de-DE')}`,
          start_time: new Date().toISOString(),
          exercises_completed: [],
          sync_source: 'body_transformation'
        };

        const { data: session, error } = await supabase
          .from('workout_sessions')
          .insert(sessionData)
          .select()
          .single();

        if (!error) {
          setWorkoutSession(session);
          console.log('✅ Workout Session erstellt');
        }
      }

      // Setze Workout-State
      setCurrentWorkout(selectedPlan);
      setCurrentExerciseIndex(0);
      setCurrentSet(1);
      setWorkoutTimer(0);
      setExerciseTimer(0);
      setRestTimer(0);
      setIsWorkoutActive(true);
      setIsWorkoutPaused(false);
      setIsResting(false);
      setCompletedExercises([]);
      setShowWorkoutScreen(true);

    } catch (error) {
      console.error('Error starting workout:', error);
    }
  };

  const pauseWorkout = () => {
    setIsWorkoutPaused(!isWorkoutPaused);
  };

  const completeExercise = () => {
    if (!currentWorkout || !currentWorkout.exercises || currentExerciseIndex >= currentWorkout.exercises.length) {
      console.error('Keine gültige aktuelle Übung gefunden');
      return;
    }

    setShowRepInputModal(true);
  };

  const handleRepSubmit = (reps) => {
    const currentExercise = currentWorkout.exercises[currentExerciseIndex];
    const exerciseData = {
      exercise: currentExercise.name,
      sets_completed: currentSet,
      reps_completed: reps,
      weight_used: 0, // Bodyweight
      duration: exerciseTimer,
      completed_at: new Date().toISOString()
    };

    setCompletedExercises(prev => [...prev, exerciseData]);
    setShowRepInputModal(false);
    
    // Nächste Übung oder Workout beenden
    if (currentExerciseIndex < currentWorkout.exercises.length - 1) {
      setCurrentExerciseIndex(prev => prev + 1);
      setCurrentSet(1);
      setExerciseTimer(0);
      startRest(currentExercise.rest || 60);
    } else {
      completeWorkout();
    }
  };

  const startRest = (seconds) => {
    setIsResting(true);
    setRestTimer(seconds);
  };

  const skipRest = () => {
    setIsResting(false);
    setRestTimer(0);
  };

  const completeWorkout = async () => {
    try {
      if (workoutSession) {
        const totalDuration = Math.floor(workoutTimer / 60);
        const estimatedCalories = Math.floor(totalDuration * 10); // Höhere Schätzung für intensives Training

        // Update Workout Session
        const { error: updateError } = await supabase
          .from('workout_sessions')
          .update({
            end_time: new Date().toISOString(),
            duration_minutes: totalDuration,
            calories_burned: estimatedCalories,
            exercises_completed: completedExercises
          })
          .eq('id', workoutSession.id);

        if (updateError) {
          console.error('Error updating workout session:', updateError);
        }
      }

      // Reset Workout State
      setIsWorkoutActive(false);
      setShowWorkoutScreen(false);
      setCurrentWorkout(null);
      setWorkoutSession(null);

      // Reload Progress Data
      await loadWorkoutProgress();

      console.log('🎉 Body Transformation Workout abgeschlossen!');

    } catch (error) {
      console.error('Error completing workout:', error);
    }
  };

  // CLARA'S COACHING FUNKTIONEN
  const getAIRecommendations = async () => {
    try {
      const aiContext = {
        userProfile: fitnessData,
        healthData: healthData,
        challengeProgress: challengeData,
        recentWorkouts: workoutSessions.slice(0, 5)
      };

      const recommendations = await generateAIWorkoutRecommendations(aiContext);
      setAiRecommendations(recommendations);

    } catch (error) {
      console.error('Error getting AI recommendations:', error);
    }
  };

  const generateAIWorkoutRecommendations = async (context) => {
    const recommendations = [];

    // Empfehlung basierend auf aktueller Phase
    if (context.challengeProgress?.currentPhase === 1 && context.challengeProgress?.daysPassed > 20) {
      recommendations.push({
        id: 1,
        title: 'Bereit für Strength Phase?',
        description: `Du bist seit ${context.challengeProgress.daysPassed} Tagen dabei! Überlege, ob du zur Strength Phase wechseln möchtest für mehr Herausforderung.`,
        type: 'progression'
      });
    }

    // Empfehlung basierend auf Health Score
    if (context.healthData?.healthScore < 60) {
      recommendations.push({
        id: 2,
        title: 'Fokus auf Regeneration',
        description: 'Dein Health Score ist unter 60. Ein leichteres Workout oder zusätzliche Erholung könnte heute sinnvoll sein.',
        type: 'recovery'
      });
    }

    // Empfehlung basierend auf Streak
    if (context.challengeProgress?.streak > 5) {
      recommendations.push({
        id: 3,
        title: 'Fantastischer Streak!',
        description: `${context.challengeProgress.streak} Tage in Folge! Deine Body Transformation läuft perfekt. Weiter so!`,
        type: 'motivation'
      });
    }

    // Fallback-Empfehlung
    if (recommendations.length === 0) {
      recommendations.push({
        id: 4,
        title: 'Bereit für Body Transformation!',
        description: 'Deine Werte sehen gut aus. Zeit für ein intensives Workout für deine Transformation!',
        type: 'motivation'
      });
    }

    return recommendations;
  };

  useEffect(() => {
    if (challengeData && healthData) {
      getAIRecommendations();
    }
  }, [challengeData, healthData]);

  // ERNÄHRUNGS-KI-FUNKTIONEN
  const handleMealPhotoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setMealPhoto(e.target.files[0]);
    }
  };

  const analyzeMealPhoto = async () => {
    if (!mealPhoto || !nutritionService) return;

    try {
      setMealAnalysis({ status: 'analyzing' });
      const analysis = await nutritionService.analyzeMealFromImage(mealPhoto);
      setMealAnalysis({ status: 'completed', data: analysis });
    } catch (error) {
      console.error('Error analyzing meal photo:', error);
      setMealAnalysis({ status: 'error', message: 'Analyse fehlgeschlagen' });
    }
  };

  // MANUELLER HEALTH DATA REFRESH
  const refreshHealthData = async () => {
    if (!healthService) return;
    
    try {
      setHealthSyncStatus('syncing');
      const freshData = await healthService.getHealthData();
      setHealthData(freshData);
      setHealthScore(freshData.healthScore);
      setLastSyncTime(freshData.lastSync);
      setHealthSyncStatus(freshData.isConnected ? 'connected' : 'mock');
      
      console.log('🔄 Health Data manuell aktualisiert');
    } catch (error) {
      console.error('❌ Manueller Health Data Refresh fehlgeschlagen:', error);
      setHealthSyncStatus('error');
    }
  };

  const saveProfile = async () => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      if (!currentUser) return;

      const { error } = await supabase
        .from('user_fitness_goals')
        .upsert({
          user_id: currentUser.id,
          ...profileForm
        });

      if (error) {
        console.error('Error saving profile:', error);
      } else {
        setShowProfileModal(false);
        loadUserData();
      }
    } catch (error) {
      console.error('Error saving profile:', error);
    }
  };

  const logWorkout = async () => {
    try {
      const newLog = {
        id: trainingLogs.length + 1,
        ...workoutForm,
        date: new Date().toISOString().split('T')[0]
      };
      
      setTrainingLogs([newLog, ...trainingLogs]);
      setWorkoutForm({ exercise: '', weight: '', sets: '', reps: '', notes: '' });
      setShowWorkoutModal(false);
    } catch (error) {
      console.error('Error logging workout:', error);
    }
  };

  const addWaterIntake = async (amount) => {
    try {
      const { data: { user: currentUser } } = await supabase.auth.getUser();
      if (!currentUser) {
        setWaterIntake(prev => prev + amount);
        setNutritionData(prev => ({
          ...prev,
          water: (waterIntake + amount) / 1000
        }));
        return;
      }

      const { error } = await supabase
        .from('water_intake')
        .insert({
          user_id: currentUser.id,
          amount_ml: amount,
          intake_date: new Date().toISOString().split('T')[0],
          intake_time: new Date().toTimeString().split(' ')[0]
        });

      if (error) {
        console.error('Error adding water intake:', error);
      } else {
        setWaterIntake(prev => prev + amount);
        loadNutritionData();
      }
    } catch (error) {
      console.error('Error adding water intake:', error);
    }
  };

  // SPRACHERKENNUNG
  const toggleListening = () => {
    if (isListening) {
      recognitionRef.current.stop();
      setIsListening(false);
    } else {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (SpeechRecognition) {
        recognitionRef.current = new SpeechRecognition();
        recognitionRef.current.continuous = true;
        recognitionRef.current.lang = 'de-DE';
        recognitionRef.current.onresult = (event) => {
          const transcript = event.results[event.results.length - 1][0].transcript.trim();
          console.log('Spracherkennung:', transcript);
          handleVoiceCommand(transcript);
        };
        recognitionRef.current.start();
        setIsListening(true);
      } else {
        console.error('Speech Recognition not supported');
      }
    }
  };

  const handleVoiceCommand = (command) => {
    const number = parseInt(command.match(/\d+/));
    if (command.includes('geschafft') && number) {
      handleRepSubmit(number);
    } else if (command.includes('Pause')) {
      pauseWorkout();
    } else if (command.includes('weiter')) {
      completeExercise();
    }
  };

  // Sichere Array-Filter
  const filteredExercises = (exerciseLibrary || []).filter(exercise => {
    const equipmentMatch = selectedEquipment === 'all' || exercise.equipment === selectedEquipment;
    const difficultyMatch = selectedDifficulty === 'all' || exercise.difficulty_level.toString() === selectedDifficulty;
    return equipmentMatch && difficultyMatch;
  });

  // HEALTH SYNC STATUS INDICATOR
  const getHealthSyncStatusColor = () => {
    switch (healthSyncStatus) {
      case 'connected': return 'text-green-500';
      case 'mock': return 'text-yellow-500';
      case 'syncing': return 'text-blue-500';
      case 'error': return 'text-red-500';
      default: return 'text-gray-500';
    }
  };

  const getHealthSyncStatusText = () => {
    switch (healthSyncStatus) {
      case 'connected': return 'Live verbunden';
      case 'mock': return 'Demo-Modus';
      case 'syncing': return 'Synchronisiert...';
      case 'error': return 'Verbindungsfehler';
      case 'initializing': return 'Initialisiert...';
      default: return 'Unbekannt';
    }
  };

  // UTILITY FUNKTIONEN
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="text-white text-xl mb-4">Lade Vital Center...</div>
          <div className="text-slate-400 text-sm">Initialisiere 90-Tage Body Transformation...</div>
        </div>
      </div>
    );
  }

  // WORKOUT SCREEN - VOLLSTÄNDIGE ÜBUNGSFÜHRUNG
  if (showWorkoutScreen && currentWorkout && isWorkoutActive && currentWorkout.exercises && currentWorkout.exercises.length > 0) {
    const currentExercise = currentWorkout.exercises[currentExerciseIndex];
    if (!currentExercise) {
      setShowWorkoutScreen(false);
      setIsWorkoutActive(false);
      return null;
    }

    const progress = ((currentExerciseIndex + 1) / currentWorkout.exercises.length) * 100;

    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-6">
        <div className="max-w-4xl mx-auto">
          {/* Workout Header */}
          <div className={`bg-gradient-to-r ${currentWorkout.color} rounded-2xl p-6 mb-6 border border-opacity-60`}>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h1 className="text-2xl font-bold text-white">{currentWorkout.name}</h1>
                <p className="text-white text-opacity-80">Übung {currentExerciseIndex + 1} von {currentWorkout.exercises.length}</p>
              </div>
              <div className="text-right">
                <div className="text-3xl font-bold text-white">{formatTime(workoutTimer)}</div>
                <div className="text-white text-opacity-80 text-sm">Gesamtzeit</div>
              </div>
            </div>
            
            {/* Progress Bar */}
            <div className="w-full bg-white bg-opacity-20 rounded-full h-3 mb-4">
              <div 
                className="bg-gradient-to-r from-yellow-400 to-orange-400 h-3 rounded-full transition-all duration-500"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>

          {/* Current Exercise */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-700 rounded-2xl p-8 mb-6 border border-slate-600">
            <h2 className="text-3xl font-bold text-white mb-4 text-center">{currentExercise.name}</h2>
            
            {/* Exercise Stats */}
            <div className="grid grid-cols-3 gap-6 mb-6">
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-blue-400">{currentExercise.sets}</div>
                <div className="text-slate-300 text-sm">Sets</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-green-400">{currentExercise.reps}</div>
                <div className="text-slate-300 text-sm">Reps</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-orange-400">{currentExercise.rest}s</div>
                <div className="text-slate-300 text-sm">Pause</div>
              </div>
            </div>
            
            {/* Detailed Instructions */}
            <div className="bg-slate-700 rounded-xl p-6 mb-6">
              <h3 className="text-lg font-bold text-white mb-3">Ausführung:</h3>
              <p className="text-slate-300 mb-4">{currentExercise.instructions}</p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-blue-400 font-semibold">Progression:</span>
                  <p className="text-slate-300">{currentExercise.progression}</p>
                </div>
                <div>
                  <span className="text-green-400 font-semibold">Zielmuskulatur:</span>
                  <p className="text-slate-300">{currentExercise.muscles}</p>
                </div>
              </div>
            </div>

            {/* Current Set Info */}
            <div className="text-center mb-6">
              <div className="text-2xl font-bold text-white mb-2">Set {currentSet} von {currentExercise.sets}</div>
              <div className="text-xl text-slate-300">{formatTime(exerciseTimer)}</div>
            </div>
          </div>

          {/* Rest Timer */}
          {isResting && (
            <div className="bg-gradient-to-r from-orange-800 to-orange-700 rounded-2xl p-6 mb-6 border border-orange-600 text-center">
              <h3 className="text-xl font-bold text-white mb-4">Pause</h3>
              <div className="text-4xl font-bold text-white mb-4">{formatTime(restTimer)}</div>
              <p className="text-orange-200 mb-4">Bereite dich auf die nächste Übung vor</p>
              <button 
                onClick={skipRest}
                className="bg-orange-600 hover:bg-orange-500 text-white px-6 py-2 rounded-xl font-semibold transition-colors"
              >
                Pause überspringen
              </button>
            </div>
          )}

          {/* Workout Controls */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-700 rounded-2xl p-6 border border-slate-600">
            <div className="flex justify-center gap-4 flex-wrap">
              <button 
                onClick={pauseWorkout}
                className={`${isWorkoutPaused ? 'bg-green-600 hover:bg-green-500' : 'bg-yellow-600 hover:bg-yellow-500'} text-white px-6 py-3 rounded-xl font-semibold transition-colors flex items-center gap-2`}
              >
                {isWorkoutPaused ? <Play size={20} /> : <Pause size={20} />}
                {isWorkoutPaused ? 'Fortsetzen' : 'Pausieren'}
              </button>
              
              {!isResting && (
                <button 
                  onClick={() => {
                    if (currentSet < currentExercise.sets) {
                      setCurrentSet(prev => prev + 1);
                      setExerciseTimer(0);
                      startRest(currentExercise.rest || 60);
                    } else {
                      completeExercise();
                    }
                  }}
                  className="bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 rounded-xl font-semibold transition-colors flex items-center gap-2"
                >
                  <CheckCircle size={20} />
                  {currentSet < currentExercise.sets ? 'Set abgeschlossen' : 'Übung abgeschlossen'}
                </button>
              )}
              
              <button 
                onClick={() => {
                  setIsWorkoutActive(false);
                  setShowWorkoutScreen(false);
                }}
                className="bg-red-600 hover:bg-red-500 text-white px-6 py-3 rounded-xl font-semibold transition-colors"
              >
                Workout beenden
              </button>

              <button 
                onClick={toggleListening}
                className={`${isListening ? 'bg-red-600 hover:bg-red-500' : 'bg-blue-600 hover:bg-blue-500'} text-white px-6 py-3 rounded-xl font-semibold transition-colors flex items-center gap-2`}
              >
                {isListening ? <MicOff size={20} /> : <Mic size={20} />}
                {isListening ? 'Stop' : 'Spracheingabe'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <div className="bg-gradient-to-r from-emerald-500 to-green-500 p-3 rounded-xl">
              <Dumbbell className="text-white" size={32} />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">Clara Vital Center</h1>
              <p className="text-slate-400">90-Tage Body Transformation mit Samsung Health Integration</p>
            </div>
          </div>
          <button 
            onClick={() => setShowProfileModal(true)}
            className="bg-gradient-to-r from-cyan-600 to-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-cyan-700 hover:to-blue-700 transition-all duration-200 flex items-center gap-2"
          >
            <User size={20} />
            Profil
          </button>
        </div>

        {/* AI COACH RECOMMENDATIONS */}
        {aiRecommendations.length > 0 && (
          <div className="bg-gradient-to-r from-blue-800 to-blue-700 rounded-2xl p-6 mb-8 border border-blue-600">
            <div className="flex items-center gap-3 mb-4">
              <BrainCircuit className="text-blue-300" size={24} />
              <h3 className="text-xl font-bold text-white">KI-Coach Empfehlungen</h3>
            </div>
            <div className="space-y-3">
              {aiRecommendations.map(rec => (
                <div key={rec.id} className="bg-blue-700 rounded-xl p-4">
                  <h4 className="text-white font-semibold mb-1">{rec.title}</h4>
                  <p className="text-blue-200 text-sm">{rec.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ENHANCED SAMSUNG HEALTH STATUS CARD */}
        {healthData && (
          <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-2xl p-6 mb-8 border border-slate-600">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="bg-green-500 p-2 rounded-lg">
                  <Watch className="text-white" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white">Samsung Health Connect</h3>
                  <p className={`text-sm ${getHealthSyncStatusColor()}`}>
                    {getHealthSyncStatusText()}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {healthConnected ? (
                  <Wifi className="text-green-500" size={20} />
                ) : (
                  <WifiOff className="text-orange-500" size={20} />
                )}
                <button 
                  onClick={refreshHealthData}
                  disabled={healthSyncStatus === 'syncing'}
                  className="bg-slate-600 hover:bg-slate-500 text-white p-2 rounded-lg transition-colors disabled:opacity-50"
                >
                  <Activity size={16} className={healthSyncStatus === 'syncing' ? 'animate-spin' : ''} />
                </button>
              </div>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-blue-400">{healthData.steps?.toLocaleString() || '0'}</div>
                <div className="text-slate-300 text-sm">Schritte</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-red-400 flex items-center justify-center gap-1">
                  <Heart size={20} />
                  {healthData.heartRate || '0'}
                </div>
                <div className="text-slate-300 text-sm">BPM</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-orange-400">{healthData.calories?.toLocaleString() || '0'}</div>
                <div className="text-slate-300 text-sm">Kalorien</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-4 text-center">
                <div className="text-2xl font-bold text-purple-400">{healthData.sleep || '0'}h</div>
                <div className="text-slate-300 text-sm">Schlaf</div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4">
              <div className="bg-slate-700 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-green-400">{healthData.activeMinutes || '0'}</div>
                <div className="text-slate-300 text-xs">Aktive Min</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-cyan-400">{healthData.distance || '0'} km</div>
                <div className="text-slate-300 text-xs">Distanz</div>
              </div>
              <div className="bg-slate-700 rounded-xl p-3 text-center">
                <div className="text-lg font-bold text-pink-400">{healthData.workouts?.length || '0'}</div>
                <div className="text-slate-300 text-xs">Workouts</div>
              </div>
            </div>
            
            <div className="text-center text-slate-400 text-sm">
              Letzte Synchronisation: {lastSyncTime ? new Date(lastSyncTime).toLocaleString('de-DE') : 'Nie'}
            </div>
          </div>
        )}

        {/* ENHANCED HEALTH SCORE */}
        {healthData && (
          <div className="bg-gradient-to-r from-emerald-800 to-emerald-700 rounded-2xl p-6 mb-8 border border-emerald-600">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-xl font-bold text-white mb-2">Health Score</h3>
                <p className="text-emerald-200">Basierend auf Samsung Health Daten</p>
                <p className="text-emerald-300 text-sm mt-1">
                  {healthConnected ? '🔴 Live-Daten' : '🟡 Demo-Daten'}
                </p>
              </div>
              <div className="text-right">
                <div className="text-4xl font-bold text-white">{healthScore}</div>
                <div className="text-emerald-200">/100</div>
                <div className="text-emerald-300 text-sm mt-1">
                  {healthScore >= 80 ? 'Ausgezeichnet' : 
                   healthScore >= 60 ? 'Gut' : 
                   healthScore >= 40 ? 'Durchschnitt' : 'Verbesserung nötig'}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 90-TAGE BODY TRANSFORMATION */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-white">90-Tage Body Transformation</h2>
            <div className="flex gap-3">
              {!activeWorkoutPlan ? (
                <button 
                  onClick={start90DayTransformation}
                  className="bg-gradient-to-r from-purple-600 to-purple-500 text-white px-6 py-2 rounded-xl font-semibold hover:from-purple-700 hover:to-purple-600 transition-all duration-200 flex items-center gap-2"
                >
                  <Trophy size={16} />
                  Transformation starten
                </button>
              ) : (
                <button 
                  onClick={() => startWorkout()}
                  className="bg-gradient-to-r from-emerald-500 to-green-500 text-white px-6 py-2 rounded-xl font-semibold hover:from-emerald-600 hover:to-green-600 transition-all duration-200 flex items-center gap-2"
                >
                  <Play size={16} />
                  Workout starten
                </button>
              )}
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {bodyTransformationProgram.map((plan) => (
              <div key={plan.id} className={`bg-gradient-to-br ${plan.color} rounded-2xl p-6 border border-opacity-60 transition-all hover:scale-105 ${
                challengeData?.currentPhase === plan.phase ? 'ring-2 ring-yellow-400' : ''
              }`}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-bold text-white">{plan.name}</h3>
                  <div className="flex items-center gap-2">
                    {challengeData?.currentPhase === plan.phase && (
                      <div className="bg-yellow-400 text-black px-2 py-1 rounded text-xs font-bold">
                        AKTIV
                      </div>
                    )}
                    {activeWorkoutPlan && (
                      <button 
                        onClick={() => startWorkout(plan.phase)}
                        className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white p-2 rounded-lg transition-colors"
                      >
                        <Play size={16} />
                      </button>
                    )}
                  </div>
                </div>
                <p className="text-white text-opacity-90 text-sm mb-4">{plan.description}</p>
                <div className="flex justify-between items-center text-sm mb-4">
                  <span className="text-white text-opacity-80">{plan.duration_days} Tage</span>
                  <span className="text-white text-opacity-80">{plan.workouts_per_week}x/Woche</span>
                  <span className="text-white text-opacity-80">Level {plan.difficulty_level}</span>
                </div>
                
                {/* Übungen Preview */}
                <div className="space-y-2">
                  {plan.exercises.slice(0, 3).map((exercise, index) => (
                    <div key={index} className="bg-white bg-opacity-10 rounded-lg p-2 text-sm">
                      <div className="text-white font-medium">{exercise.name}</div>
                      <div className="text-white text-opacity-80">{exercise.sets} Sets × {exercise.reps}</div>
                    </div>
                  ))}
                  {plan.exercises.length > 3 && (
                    <div className="text-white text-opacity-70 text-xs text-center">
                      +{plan.exercises.length - 3} weitere Übungen
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {/* Challenge Progress */}
          <div className="bg-gradient-to-br from-purple-800 to-purple-700 rounded-2xl p-6 border border-purple-600">
            <div className="flex items-center gap-3 mb-4">
              <Trophy className="text-yellow-400" size={24} />
              <h3 className="text-lg font-semibold text-white">Transformation</h3>
            </div>
            {challengeData && (
              <div>
                <p className="text-purple-200 text-sm mb-2">{challengeData.currentChallenge}</p>
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex-1 bg-purple-900 rounded-full h-2">
                    <div 
                      className="bg-gradient-to-r from-yellow-400 to-orange-400 h-2 rounded-full transition-all duration-500"
                      style={{ width: `${challengeData.progress}%` }}
                    ></div>
                  </div>
                  <span className="text-white text-sm font-semibold">{challengeData.progress}%</span>
                </div>
                <p className="text-purple-200 text-xs">
                  {challengeData.daysRemaining} Tage verbleibend • Tag {challengeData.daysPassed || 0}
                </p>
                <p className="text-purple-200 text-xs mt-1">
                  {challengeData.totalWorkouts} Workouts • Phase {challengeData.currentPhase}
                </p>
              </div>
            )}
          </div>

          {/* Weekly Stats */}
          <div className="bg-gradient-to-br from-emerald-800 to-emerald-700 rounded-2xl p-6 border border-emerald-600">
            <div className="flex items-center gap-3 mb-4">
              <BarChart3 className="text-emerald-300" size={24} />
              <h3 className="text-lg font-semibold text-white">Diese Woche</h3>
            </div>
            {weeklyStats && (
              <div className="space-y-2">
                <div className="flex justify-between">
                  <span className="text-emerald-200 text-sm">Workouts</span>
                  <span className="text-white font-semibold">{weeklyStats.workoutsCompleted}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-emerald-200 text-sm">Minuten</span>
                  <span className="text-white font-semibold">{weeklyStats.totalMinutes}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-emerald-200 text-sm">Kalorien</span>
                  <span className="text-white font-semibold">{weeklyStats.caloriesBurned}</span>
                </div>
              </div>
            )}
          </div>

          {/* Streak */}
          <div className="bg-gradient-to-br from-orange-800 to-orange-700 rounded-2xl p-6 border border-orange-600">
            <div className="flex items-center gap-3 mb-4">
              <Flame className="text-orange-300" size={24} />
              <h3 className="text-lg font-semibold text-white">Streak</h3>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">{challengeData?.streak || 0}</div>
              <p className="text-orange-200 text-sm">Tage in Folge</p>
            </div>
          </div>

          {/* ERNÄHRUNGS-QUICK-STATS */}
          <div className="bg-gradient-to-br from-cyan-800 to-cyan-700 rounded-2xl p-6 border border-cyan-600">
            <div className="flex items-center gap-3 mb-4">
              <Apple className="text-cyan-300" size={24} />
              <h3 className="text-lg font-semibold text-white">Ernährung</h3>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-cyan-200 text-sm">Kalorien</span>
                <span className="text-white font-semibold">{nutritionData?.calories?.toFixed(0) || '0'}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-cyan-200 text-sm">Protein</span>
                <span className="text-white font-semibold">{nutritionData?.protein?.toFixed(0) || '0'}g</span>
              </div>
              <div className="flex justify-between">
                <span className="text-cyan-200 text-sm">Wasser</span>
                <span className="text-white font-semibold">{(waterIntake / 1000).toFixed(1)}L</span>
              </div>
            </div>
            <button 
              onClick={() => setShowNutritionModal(true)}
              className="w-full mt-3 bg-cyan-600 hover:bg-cyan-500 text-white py-1 rounded-lg text-sm font-semibold transition-colors flex items-center justify-center gap-1"
            >
              <Camera size={12} />
              Mahlzeit
            </button>
          </div>
        </div>

        {/* Recent Training Logs */}
        <div className="bg-gradient-to-br from-slate-800 to-slate-700 rounded-2xl p-6 mb-8 border border-slate-600">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-white">Letzte Trainings</h3>
            <button 
              onClick={() => setShowWorkoutModal(true)}
              className="bg-gradient-to-r from-emerald-500 to-green-500 text-white px-4 py-2 rounded-lg font-semibold hover:from-emerald-600 hover:to-green-600 transition-all duration-200 flex items-center gap-2"
            >
              <Plus size={16} />
              Training eintragen
            </button>
          </div>
          
          <div className="space-y-3">
            {(trainingLogs || []).slice(0, 5).map((log, index) => (
              <div key={log.id} className="bg-slate-700 rounded-xl p-4 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="bg-emerald-500 p-2 rounded-lg">
                    <Dumbbell className="text-white" size={16} />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold">{log.exercise}</h4>
                    <p className="text-slate-300 text-sm">{log.sets} Sets × {log.reps} Reps {log.weight > 0 && `@ ${log.weight}kg`}</p>
                  </div>
                </div>
                <div className="text-slate-400 text-sm">{log.date}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Exercise Library */}
        <div className="bg-gradient-to-br from-slate-800 to-slate-700 rounded-2xl p-6 border border-slate-600">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-white">Übungs-Bibliothek</h3>
            <div className="flex gap-3">
              <select 
                value={selectedEquipment}
                onChange={(e) => setSelectedEquipment(e.target.value)}
                className="bg-slate-600 text-white rounded-lg px-3 py-2 border border-slate-500 focus:border-emerald-500 focus:outline-none"
              >
                <option value="all">Alle Geräte</option>
                <option value="bodyweight">Körpergewicht</option>
                <option value="dumbbells">Hanteln</option>
                <option value="kettlebell">Kettlebell</option>
                <option value="bands">Bänder</option>
              </select>
              <select 
                value={selectedDifficulty}
                onChange={(e) => setSelectedDifficulty(e.target.value)}
                className="bg-slate-600 text-white rounded-lg px-3 py-2 border border-slate-500 focus:border-emerald-500 focus:outline-none"
              >
                <option value="all">Alle Level</option>
                <option value="1">Anfänger</option>
                <option value="2">Fortgeschritten</option>
                <option value="3">Experte</option>
              </select>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredExercises.map((exercise, index) => (
              <div key={exercise.id} className="bg-slate-700 rounded-xl p-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="text-white font-semibold">{exercise.name}</h4>
                  <div className="flex items-center gap-1">
                    {[...Array(exercise.difficulty_level)].map((_, i) => (
                      <Star key={i} className="text-yellow-400" size={12} fill="currentColor" />
                    ))}
                  </div>
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="bg-slate-600 text-slate-300 px-2 py-1 rounded text-xs">{exercise.category}</span>
                  <span className="bg-slate-600 text-slate-300 px-2 py-1 rounded text-xs">{exercise.equipment}</span>
                </div>
                <div className="text-slate-300 text-sm">
                  Zielmuskulatur: {exercise.target_muscles?.join(', ') || 'Nicht angegeben'}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* PROFILE MODAL */}
      {showProfileModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-2xl p-6 w-full max-w-md border border-slate-600">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Fitness-Profil</h3>
              <button 
                onClick={() => setShowProfileModal(false)}
                className="text-slate-400 hover:text-white"
              >
                ×
              </button>
            </div>
            
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Größe (cm)</label>
                  <input 
                    type="number" 
                    value={profileForm.height_cm}
                    onChange={(e) => setProfileForm({...profileForm, height_cm: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    placeholder="180"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Aktuelles Gewicht (kg)</label>
                  <input 
                    type="number" 
                    value={profileForm.current_weight_kg}
                    onChange={(e) => setProfileForm({...profileForm, current_weight_kg: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    placeholder="75"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Zielgewicht (kg)</label>
                <input 
                  type="number" 
                  value={profileForm.goal_weight_kg}
                  onChange={(e) => setProfileForm({...profileForm, goal_weight_kg: e.target.value})}
                  className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                  placeholder="70"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Fitness-Level</label>
                <select 
                  value={profileForm.fitness_level}
                  onChange={(e) => setProfileForm({...profileForm, fitness_level: e.target.value})}
                  className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                >
                  <option value="beginner">Anfänger</option>
                  <option value="intermediate">Fortgeschritten</option>
                  <option value="advanced">Experte</option>
                </select>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Trainingstage/Woche</label>
                  <input 
                    type="number" 
                    value={profileForm.preferred_workout_days}
                    onChange={(e) => setProfileForm({...profileForm, preferred_workout_days: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    min="1" max="7"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Dauer (Min)</label>
                  <input 
                    type="number" 
                    value={profileForm.preferred_workout_duration}
                    onChange={(e) => setProfileForm({...profileForm, preferred_workout_duration: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    placeholder="45"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Bevorzugte Trainingszeit</label>
                <select 
                  value={profileForm.preferred_workout_time}
                  onChange={(e) => setProfileForm({...profileForm, preferred_workout_time: e.target.value})}
                  className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                >
                  <option value="morning">Morgens</option>
                  <option value="afternoon">Nachmittags</option>
                  <option value="evening">Abends</option>
                </select>
              </div>
            </div>
            
            <div className="flex gap-3 mt-6">
              <button 
                onClick={() => setShowProfileModal(false)}
                className="flex-1 bg-slate-600 hover:bg-slate-500 text-white py-2 rounded-lg font-semibold transition-colors"
              >
                Abbrechen
              </button>
              <button 
                onClick={saveProfile}
                className="flex-1 bg-gradient-to-r from-emerald-500 to-green-500 text-white py-2 rounded-lg font-semibold"
              >
                Speichern
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NUTRITION MODAL */}
      {showNutritionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-2xl p-6 w-full max-w-md border border-slate-600">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Ernährungs-Tracking</h3>
              <button 
                onClick={() => setShowNutritionModal(false)}
                className="text-slate-400 hover:text-white"
              >
                ×
              </button>
            </div>
            
            <div className="space-y-4">
              <div className="text-center">
                <div className="bg-cyan-700 rounded-xl p-4 mb-4">
                  <div className="text-2xl font-bold text-white mb-2">{nutritionData?.calories?.toFixed(0) || '0'}</div>
                  <div className="text-cyan-200 text-sm">Kalorien heute</div>
                </div>
                
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className="bg-slate-700 rounded-xl p-3 text-center">
                    <div className="text-lg font-bold text-white">{nutritionData?.protein?.toFixed(0) || '0'}g</div>
                    <div className="text-slate-300 text-sm">Protein</div>
                  </div>
                  <div className="bg-slate-700 rounded-xl p-3 text-center">
                    <div className="text-lg font-bold text-white">{(waterIntake / 1000).toFixed(1)}L</div>
                    <div className="text-slate-300 text-sm">Wasser</div>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="text-slate-300 text-sm mb-2">Wasser hinzufügen:</div>
                  <div className="flex gap-2">
                    <button 
                      onClick={() => addWaterIntake(250)}
                      className="flex-1 bg-blue-600 hover:bg-blue-500 text-white py-2 rounded-lg text-sm transition-colors"
                    >
                      +250ml
                    </button>
                    <button 
                      onClick={() => addWaterIntake(500)}
                      className="flex-1 bg-blue-600 hover:bg-blue-500 text-white py-2 rounded-lg text-sm transition-colors"
                    >
                      +500ml
                    </button>
                  </div>
                </div>
              </div>

              {/* FOTO-ANALYSE */}
              <div className="border-t border-slate-700 pt-4">
                <h4 className="text-lg font-semibold text-white mb-3">Mahlzeit-Analyse per Foto</h4>
                <input 
                  type="file" 
                  accept="image/*" 
                  onChange={handleMealPhotoChange}
                  className="w-full text-sm text-slate-300 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700"
                />
                {mealPhoto && (
                  <button 
                    onClick={analyzeMealPhoto}
                    disabled={mealAnalysis?.status === 'analyzing'}
                    className="w-full mt-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white py-2 rounded-lg font-semibold transition-colors disabled:opacity-50"
                  >
                    {mealAnalysis?.status === 'analyzing' ? 'Analysiere...' : 'Analyse starten'}
                  </button>
                )}

                {mealAnalysis?.status === 'completed' && (
                  <div className="bg-slate-700 rounded-xl p-4 mt-4">
                    <h5 className="text-white font-semibold mb-2">Analyse-Ergebnis:</h5>
                    <p className="text-slate-300 text-sm">{mealAnalysis.data.description}</p>
                    <div className="grid grid-cols-2 gap-2 mt-3 text-xs">
                      <div className="text-slate-300">Kalorien: <span className="font-semibold text-white">{mealAnalysis.data.calories}</span></div>
                      <div className="text-slate-300">Protein: <span className="font-semibold text-white">{mealAnalysis.data.protein}g</span></div>
                      <div className="text-slate-300">Fett: <span className="font-semibold text-white">{mealAnalysis.data.fat}g</span></div>
                      <div className="text-slate-300">KH: <span className="font-semibold text-white">{mealAnalysis.data.carbs}g</span></div>
                    </div>
                  </div>
                )}
                {mealAnalysis?.status === 'error' && (
                  <div className="text-red-400 text-sm mt-3">{mealAnalysis.message}</div>
                )}
              </div>
            </div>
            
            <div className="flex gap-3 mt-6">
              <button 
                onClick={() => setShowNutritionModal(false)}
                className="flex-1 bg-slate-600 hover:bg-slate-500 text-white py-2 rounded-lg font-semibold transition-colors"
              >
                Schließen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* WORKOUT MODAL */}
      {showWorkoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-2xl p-6 w-full max-w-md border border-slate-600">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Training eintragen</h3>
              <button 
                onClick={() => setShowWorkoutModal(false)}
                className="text-slate-400 hover:text-white"
              >
                ×
              </button>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Übung</label>
                <select 
                  value={workoutForm.exercise}
                  onChange={(e) => setWorkoutForm({...workoutForm, exercise: e.target.value})}
                  className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                >
                  <option value="">Übung auswählen</option>
                  {(exerciseLibrary || []).map(exercise => (
                    <option key={exercise.id} value={exercise.name}>{exercise.name}</option>
                  ))}
                </select>
              </div>
              
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Gewicht (kg)</label>
                  <input 
                    type="number" 
                    value={workoutForm.weight}
                    onChange={(e) => setWorkoutForm({...workoutForm, weight: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    placeholder="0"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Sets</label>
                  <input 
                    type="number" 
                    value={workoutForm.sets}
                    onChange={(e) => setWorkoutForm({...workoutForm, sets: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    placeholder="3"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-300 mb-2">Reps</label>
                  <input 
                    type="number" 
                    value={workoutForm.reps}
                    onChange={(e) => setWorkoutForm({...workoutForm, reps: e.target.value})}
                    className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                    placeholder="12"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-300 mb-2">Notizen (optional)</label>
                <textarea 
                  value={workoutForm.notes}
                  onChange={(e) => setWorkoutForm({...workoutForm, notes: e.target.value})}
                  className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                  placeholder="Wie hat es sich angefühlt? Besonderheiten?"
                  rows="2"
                />
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              <button 
                onClick={() => setShowWorkoutModal(false)}
                className="flex-1 bg-slate-600 hover:bg-slate-500 text-white py-2 rounded-lg font-semibold transition-colors"
              >
                Abbrechen
              </button>
              <button 
                onClick={logWorkout}
                className="flex-1 bg-gradient-to-r from-emerald-500 to-green-500 text-white py-2 rounded-lg font-semibold"
              >
                Training eintragen
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REP INPUT MODAL */}
      {showRepInputModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-slate-800 rounded-2xl p-6 w-full max-w-md border border-slate-600">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-white">Wie viele Wiederholungen?</h3>
              <button 
                onClick={() => setShowRepInputModal(false)}
                className="text-slate-400 hover:text-white"
              >
                ×
              </button>
            </div>
            
            <div className="space-y-4">
              <input 
                type="number" 
                value={currentReps}
                onChange={(e) => setCurrentReps(e.target.value)}
                className="w-full bg-slate-700 text-white rounded-lg px-3 py-2 border border-slate-600 focus:border-emerald-500 focus:outline-none"
                placeholder="12"
              />
            </div>
            <div className="flex gap-3 mt-6">
              <button 
                onClick={() => setShowRepInputModal(false)}
                className="flex-1 bg-slate-600 hover:bg-slate-500 text-white py-2 rounded-lg font-semibold transition-colors"
              >
                Abbrechen
              </button>
              <button 
                onClick={() => handleRepSubmit(currentReps)}
                className="flex-1 bg-gradient-to-r from-emerald-500 to-green-500 text-white py-2 rounded-lg font-semibold"
              >
                Bestätigen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VitalCenter;

